var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("comment-form-modal", {
        ref: "modal",
        attrs: { pending: _vm.pending, parent: _vm.parent },
        on: {
          submitted: function ($event) {
            return _vm.$emit("submitted", $event)
          },
          closed: function ($event) {
            return _vm.$emit("closed")
          },
        },
      }),
      !_vm.mobileView && (_vm.formActive || _vm.active)
        ? [
            _c("comment-form", {
              ref: "form",
              attrs: { comment: _vm.comment, pending: _vm.pending },
              on: {
                submitted: function ($event) {
                  return _vm.$emit("submitted", $event)
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }